export const HOMEPAGE = '/';
export const HEATMAP = '/heatmap';
export const PRICEMAP = '/pricemap';
export const SEARCHBAR = '/seachbar';
export const BOOKINGS = '/bookings';
export const GUIDES = '/guides';
export const TRACK = '/track';
export const INBOX = '/inbox';
export const NOTFOUND = '/signup';
export const WELCOME = '/welcome';
export const LISTPROPERTY = '/listProperty';
export const SEARCH = '/search';
export const PROPERTYSTEP = '/propertyStep';
export const DETAILSELL = '/detailSell/:propId?';
export const DETAILBUY = '/detailBuy';
export const FINISH = '/finish';
export const MODAL = '/modal';
export const MODALBOOST = '/modalBoost';
export const MODALLAST = '/modalLast';
export const PROFILE = '/profile/:profilPage?';
export const ABOUTME = '/aboutMe';
export const GOVERNMENTID = '/governmentId';
export const NATIONALIDTYPE = '/nationalIdType';
export const SINGPASS = '/singpass';
export const PASSPORT = '/passport';
export const ADDDONE = '/addDone';
export const CHOOSEIDTYPE = '/chooseIdType';
export const LISTING = '/listing';
export const REQUEST = '/request';
export const PLANS = '/plans';
export const PROMOTE = '/promote';
export const PENALTY = '/penalty';
export const TITLEDEEDS = '/titleDeeds';
export const PROOFOFFUNDS = '/proofOfFunds';
export const APPROVALINPRINCIPLE = '/approvalInPrinciple';
export const SELLINGAPROPERTY = '/sellingProperty';
export const BUYINGAPROPERTY = '/buyingProperty';
export const PASSWORD = '/password';
export const TWOFA = '/twoFA';
export const INVITEFRIENDS = '/inviteFriends';
export const VIAMAIL = '/viamail';
export const VIANUMBER = '/vianumber';
export const KUCING = '/kucing';
export const LEGAL = '/legal';
export const AVAILABLE = '/Availableproperty';
export const AVAILAIBILITY = '/AvalaibilityTime';
export const DOWNLOAD = '/download';
export const PRIVACY = '/Privacy';
export const TERMS = '/terms-of-service';
